import { requestRepublish as postRepublish } from '@/console/api/republish'
import { RepublishRequest, RepublishResponse } from '@/console/api/types'

/**
 * LOGISPRD-13362 — MASS 반품 정산 재발행. `api/republish.ts` 로 그대로 위임한다 — 재시도·클라이언트
 * 측 중복 차단 같은 로직을 얹지 않는다(서버가 클레임번호 중복을 검사하지 않는 건 화면 확인
 * 다이얼로그 문구가 맡는다).
 */
export const requestRepublish = (request: RepublishRequest): Promise<RepublishResponse> => postRepublish(request)
